
//Import React Hooks
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';

// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

// import created components  :
import Background from '../../components/background/Background.jsx'
import ProgressBar from '../../components/progressbar/ProgressBar.jsx'
import ResaValidate from '../../components/resavalidate/ResaValidate.jsx'
import Comments from '../../components/comments/Comments.jsx'
import WallyBanner from '../../components/wallybanner/WallyBanner.jsx' //<WallyBanner />

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getSelectedCreneaux, getFormules, getEleves, getFormulesEleves, getClient } from "../../store/selectors.js";

// API fetch
import axios from "axios";
import { baseURL } from '../../config/api-config.js';

//Utils 
import creneauxSorter from '../../utils/creneaux_sorter.js';
import convertHoraire from '../../utils/convert_horaire.js';
import elevesSorter from '../../utils/eleves_sorter.js';
import getTotalResa from '../../utils/total_resa.js';

//config
import { listFidelite, listNiveau } from "../../config/niveau-fidelite-config.js";

//MUI :
import Button from '@mui/material/Button';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import SkipNextIcon from '@mui/icons-material/SkipNext';

//Translate utils :
import { translator } from "../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

function Confirmation() { // full page as component imported in router
    //// -- Display a recap of the reservation = 

    const navigate = useNavigate();

    let selectedCreneaux = useSelector(getSelectedCreneaux);
    let formulesEleves = useSelector(getFormulesEleves);
    let elevesList = useSelector(getEleves);
    elevesList = elevesSorter(elevesList);
    let formulesList = useSelector(getFormules);
    let theClient = useSelector(getClient);
    const lang = useSelector(getLang) //global state : language
    let listRider = [];
    let sessionsDates = [];
    let resaCreneaux = []; //"cleaned" list, with no unchecked eleve, to replace selected creneaux 
    let datesList = [];

    //// -- at first render :
    useEffect(() => {
        //security : redirect
        if (selectedCreneaux.length === 0) {
            navigate("../calendar");
        }
    })
    //// -- 


    elevesList.map((eleve) => { // forEach eleve ...
        let creneauxEleve = [];
        selectedCreneaux.map((creneau) => {
            creneau.eleves.map((rider => { //...we browse selected creneaux...
                if (rider.id === eleve.id && eleve.checked === true) {
                    creneauxEleve.push(creneau); // ...to gather the creneaux he attends ...
                    creneauxEleve.sort((c1, c2) => creneauxSorter(c1, c2)); // ...and sort them by date/time

                }
            }))
        });
        if (creneauxEleve.length > 0) { // if the eleve attend at least 1 creneau..
            //// -- ATTN : A faire : limitation à 5 creeneaux ???
            let nbCours = creneauxEleve.length >= 5 ? 5 : creneauxEleve.length; // limit 5 session
            let formule = formulesList.filter((formule) => formule.nb_cours === nbCours); // We browse all formules to find the correct formule according to the number of creneaux he attends
            let thisRider = elevesList.filter((rider) => rider.id === eleve.id); // get infos from current eleve...
            listRider.push({ eleve: thisRider[0], creneaux: creneauxEleve, formule: formule[0] }); // ... and fill array with all infos about, eleve, creneaux and formule
            listRider.sort((e1, e2) => e1.id > e2.id ? 1 : -1);
        }

    })

    selectedCreneaux.map((creneaux) => {
        let presentRiderList = []; //list of eleves checked for this creneau
        creneaux.eleves.map((eleve) => {
            let eleveFull = elevesList.find((e) => e.id === eleve.id);
            if (eleveFull && eleveFull.checked === true) {
                sessionsDates.push(creneaux.creneau.date);
                presentRiderList.push(eleveFull);
            }
        })
        if (presentRiderList.length > 0) { //at least one checked eleve in the creneau
            resaCreneaux.push({ creneau: creneaux.creneau, eleves: presentRiderList });
        }
    }); // get dates of all selected creneaux...with at least one checked eleve


    sessionsDates.sort((d1, d2) => dayjs(d1).isAfter(dayjs(d2)) ? 1 : -1); // ... sort the dates ...
    let setDates = new Set(sessionsDates); // ... and remove the duplicated (with a set)

    datesList = Array.from(setDates); //we need this list of date to display a calendar with only days with creneaux

    function getInfosEleve(age, niveau, fidelite) {
        let infos = "";
        infos += "age : " + age;
        infos += " / " + listNiveau.find((n) => n.id === niveau).intitule;
        infos += " / " + listFidelite.find((f) => f.id === fidelite).intitule;;
        return infos;
    }




    return (
        <div className="bg-relative">
            <Background ind={1} />
            <main> {/* main is positionned absolute */}
                <div className="main-relative">

                    <WallyBanner />

                    <div className="main-progress-bar">
                        <ProgressBar currentStep={5} total={5} />
                    </div>

                    <div className="confirmation">
                        <h3>{translator("Vos formules", lang, "confirmResaFormules")}</h3>
                        <div className="confirmation-formules">
                            {
                                listRider.map((rider) => (
                                    <div key={rider.eleve.id} className="confirmation-formules-eleves">
                                        <div className="confirmation-formules-eleves-top">
                                            <div className="confirmation-formules-eleves-top-start">
                                                <p className="confirmation-formules-eleves-top-prenom">{rider.eleve.prenom}</p>
                                                <p className="confirmation-formules-eleves-top-infos-eleve">{getInfosEleve(rider.eleve.age, rider.eleve.niveau, rider.eleve.fidelite)}</p>
                                            </div>
                                            <div className="confirmation-formules-eleves-top-end">
                                                <p className="confirmation-formules-eleves-top-formule">{rider.formule.nom_formule}</p>
                                                <p className="confirmation-formules-eleves-top-tarif">{rider.formule.tarif + ",00 €"}</p>
                                            </div>
                                        </div>
                                        <div className="confirmation-formules-eleves-bottom">
                                            {rider.creneaux.map((creneau, index) => (
                                                <div key={index} className="confirmation-formules-eleves-bottom-creneaux">
                                                    <p className="confirmation-formules-eleves-bottom-creneaux-title">{"session " + (index + 1) + " :"}</p>
                                                    <p className="confirmation-formules-eleves-bottom-creneaux-details">{`le ${dayjs(creneau.creneau.date).format("DD/MM")} à ${convertHoraire(creneau.creneau.horaire, "horaire")}`}</p>
                                                </div>
                                            ))
                                            }

                                        </div>
                                    </div>

                                ))
                            }
                        </div>

                        <div className="confirmation-total">
                            <h3 className="confirmation-total-infos">{translator("Montant total de votre panier :", lang, "confirmResaCart")}</h3>
                            <h3 className="confirmation-total-montant">{getTotalResa(formulesEleves, elevesList) + ",00 €"}</h3>
                        </div>

                        <h3>{translator("Vos sessions", lang, "confirmResaSessions")}</h3>
                        <div className="confirmation-sessions">
                            <div className="confirmation-sessions-calendrier">
                                {
                                    datesList.map((date, index) => (
                                        <div className="confirmation-sessions-jour" key={index}>
                                            <div className="confirmation-sessions-jour-header">
                                                {dayjs(date).format("DD/MM/YYYY")}
                                            </div>
                                            <div className="confirmation-sessions-jour-creneaux">
                                                {
                                                    resaCreneaux.filter((creneau) => creneau.creneau.date === date).map((session) => (
                                                        <div key={session.creneau.horaire} className="confirmation-sessions-jour-session">

                                                            <div className="confirmation-sessions-jour-session-header">
                                                                <p>{convertHoraire(session.creneau.horaire, "horaire")}</p>

                                                            </div>
                                                            <div className="confirmation-sessions-jour-session-names">
                                                                {session.eleves.toSorted((e1, e2) => e1.id > e2.id ? 1 : -1).map((eleve) => (
                                                                    <p key={eleve.id}>{eleve.prenom}</p>
                                                                ))}
                                                            </div>

                                                        </div>
                                                    )
                                                    )
                                                }
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>

                        </div>

                    </div>

                    <div className="confirmation-client">
                        <h3>{translator("Vos coordonnées", lang, "confirmResaInfos")}</h3>
                        <div className="confirmation-client-infos">
                            <p>{theClient.prenom + " " + theClient.nom}</p>
                            <p>{"Téléphone : " + theClient.tel}</p>
                            <p>{"Téléphone 2 : " + theClient.tel2}</p>
                            <p>{"Email : " + theClient.email}</p>
                            {theClient.adresse_vacances != "" ?
                                <p>{"Adresse de vacances : " + theClient.adresse_vacances}</p>
                                :
                                null
                            }
                        </div>

                    </div>

                    <Comments readOnly={false} comList={[]} client={{}} />

                    <div className="bottom-nav bottom-nav-column">


                        {/* <Button
                            className="bottom-nav-next"
                            disabled={selectedCreneaux.length === 0}
                            onClick={_ => handleClick()}
                            variant="contained">
                            Suivant <SkipNextIcon />
                        </Button> */}

                        <ResaValidate clientId={theClient.id_client} />

                        <Button
                            className="bottom-nav-prev"
                            onClick={_ => navigate("../infosclient")}
                            variant="contained">
                            <SkipPreviousIcon />{translator("Précédent", lang, "BtPrevious")}
                        </Button>
                    </div>

                </div>
            </main>
        </div>
    );
}

export default Confirmation;